import { render, staticRenderFns } from "./ModalCustomer.vue?vue&type=template&id=fe092c52&scoped=true&"
import script from "./ModalCustomer.vue?vue&type=script&lang=ts&"
export * from "./ModalCustomer.vue?vue&type=script&lang=ts&"
import style0 from "./ModalCustomer.vue?vue&type=style&index=0&id=fe092c52&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe092c52",
  null
  
)

export default component.exports